import axios from 'axios'
import React, { useEffect, useState } from 'react'
import * as XLSX from 'xlsx';
import '../styles/general.css'
import Chart from 'react-apexcharts';
import { useDispatch, useSelector } from 'react-redux'
import { roundy } from './Utilities'
import {
    Dropdown,
    DropdownButton,
    Form,
    InputGroup,
    Row, Col,
    Spinner,
} from 'react-bootstrap'
import LoginModal from "../components/LoginModal"
import RegisterModal from "../components/RegisterModal"
import ForgotModal from "../components/ForgotModal"
import AddFolderModal from "../components/AddFolderModal"
import MessageModal from "../components/MessageModal"
import {
    // updateCard,
    setIndicator,
} from '../actions/searchActions'
import {
    getFolders,
} from '../actions/platformActions'
import { saveSeries } from '../actions/viewerActions'
import ViewerModal from '../components/ViewerModal'
import { SELECTED_INDICATOR } from '../constants/searchConstants'
import { SAVE_SERIES_RESET } from '../constants/viewerConstants'

const defaultColors = [
    "#FF5733", // Rojo intenso
    "#33FF57", // Verde lima
    "#3357FF", // Azul vibrante
    "#FF33A1", // Rosa fuerte
    "#FFBD33", // Naranja vibrante
    "#33FFF6", // Cian
    "#A633FF", // Púrpura
    "#FF3333", // Rojo brillante
    "#33FFBD", // Verde menta
    "#5733FF", // Azul púrpura
    "#FF9633", // Naranja cálido
    "#33A1FF", // Azul claro
    "#FF3384", // Fucsia
    "#96FF33", // Verde lima claro
    "#8C33FF", // Violeta
    "#FF3380", // Magenta
    "#33FF57", // Verde brillante
    "#FF5733", // Naranja rojizo
    "#33FFD7", // Turquesa
    "#FF33E3"  // Rosa neón
];

function SearchCard({ meta, data, countries, onFrequencyChange }) {
    //console.log('metaCard: ', meta)
    //console.log('countries: ', countries)
    //console.log('data: ', data)


    const dispatch = useDispatch()

    const [messageModal, setMessageModal] = useState('')
    const [modalTitle, setModalTitle] = useState('')
    const [modalMessage, setModalMessage] = useState('')

    const [saveType, setSaveType] = useState('')

    // const [viewerMeta, setViewerMeta] = useState(meta)
    // setCountryValue(prevCountries => [...prevCountries, { id: prevCountries.length, value: '', label: '', color: defaultColors[prevCountries.length], type: 'line', countryType: ''}])

    const userLogin = useSelector(state => state.userLogin)
    const { userInfo } = userLogin

    useEffect(() => {
        if (userInfo) {
            dispatch(getFolders())
        }
    }, [dispatch, userInfo])

    const [metaCountry, setMetaCountry] = useState([])
    const [isExpanded, setIsExpanded] = useState(false)

    // let finalMeta = JSON.parse(JSON.stringify(meta))
    // finalMeta.chart = {
    //     // unit: {value: meta.units[0], label: meta.units[0]},
    //     unit: {value: unitValue, label: unitValue},
    //     frequency: {value: meta.frequency, label: meta.frequency},
    //     country: metaCountry,
    //     legend: true,
    //     metrics: [{id: 0, value: '', label: ''}],
    //     xaxis: [{id: 0, value: '', label: ''}],
    //     yaxis: [{id: 0, value: '', label: '', text:''}],
    //     highlight: [{
    //         id: 0,
    //         x1: {value: '', label: ''},
    //         x2: {value: '', label: ''},
    //     }]
    // }


    const [loginModal, setLoginModal] = useState(false)
    const [registerModal, setRegisterModal] = useState(false)
    const [forgotModal, setForgotModal] = useState(false)

    const [viewerModal, setViewerModal] = useState(false)
    const [addFolderModal, setAddFolderModal] = useState(false)

    // const [metaSender, setMetaSender] = useState(finalMeta)

    const [realData, setRealData] = useState(data)
    const [unitValue, setUnitValue] = useState(meta.units[0])
    const [frequencyValue, setFrequencyValue] = useState(meta.frequency)
    const [definitionValue, setDefinitonValue] = useState(meta.units_definitions[meta.units[0]])
    const [numCountries, setNumCountries] = useState([...new Set(data.map(item => item.country))].length)
    const [selectedContries, setSelectedCountries] = useState([...new Set(data.map(item => item.country))])
    const [sourcesList, setSourcesList] = useState([...new Set(data.map(item => item.source))])
    // console.log("otherFrequencies: ", meta.other_frequencies)
    const [otherFrequenciesList, setOtherFrequencyList] = useState(meta.other_frequencies.reduce((a, b) => a.length > b.length ? a : b).replace('and', ','))
    const [xdata, setXdata] = useState([])
    const [ydata, setYdata] = useState([])
    const [minDate, setMinDate] = useState(null)
    const [maxDate, setMaxDate] = useState(null)

    let finalMeta = JSON.parse(JSON.stringify(meta))
    finalMeta.chart = {
        // unit: {value: meta.units[0], label: meta.units[0]},
        unit: { value: unitValue, label: unitValue },
        frequency: { value: meta.frequency, label: meta.frequency },
        country: metaCountry,
        legend: true,
        metrics: [{ id: 0, value: '', label: '' }],
        xaxis: [{ id: 0, value: '', label: '' }],
        yaxis: [{ id: 0, value: '', label: '', text: '' }],
        highlight: [{
            id: 0,
            x1: { value: '', label: '' },
            x2: { value: '', label: '' },
        }]
    }

    const [metaSender, setMetaSender] = useState(finalMeta)

    // const [ydata, setYdata] = useState()
    // Paso 1: Agrupar los datos por país
    useEffect(() => {
        const general = realData.filter(item => item.unit == unitValue)


        const groupedData = general.reduce((acc, curr) => {
            if (!acc[curr.country]) {
                acc[curr.country] = [];
            }
            acc[curr.country].push({ date: curr.date, value: curr.value });
            return acc;
        }, {});

        if (general.length > 0) {
            // Paso 2: Obtener una lista de todas las dates únicas en orden ascendente
            const x = Array.from(new Set(general.map(item => item.date))).sort();
            setXdata(x)
            //console.log("xdata: ", x)
            setMinDate(x[0].split('-')[0])
            setMaxDate(x[x.length - 1].split('-')[0])


            // Paso 3: Construir los ydata para cada país con null en las dates sin valores
            var y = Object.entries(groupedData).map(([country, values]) => {
                const ydata = x.map(date => {
                    const valueObj = values.find(item => item.date === date);

                    if (!valueObj) return null;

                    const parsed = parseFloat(valueObj.value);

                    return isNaN(parsed) ? null : parsed;
                });
                return { name: country, data: ydata };
            });

            y = y.sort((a, b) => a.name.localeCompare(b.name))

            setYdata(y)
            //   console.log("ydata::::: ", y)
            setNumCountries([...new Set(general.map(item => item.country))].length)
        }
        else {
            setXdata([])
            setYdata([{
                name: 'no data',
                data: []
            }])
            setMinDate('')
            setMaxDate('')
            setNumCountries(0)
        }

    }, [unitValue, realData])

    // Manejar cambios en countries por separado
    useEffect(() => {
        if (countries) {
            setMetaCountry(countries?.map((item, index) => {
                return {
                    id: index,
                    value: item.label,
                    label: item.label,
                    color: defaultColors[index],
                    type: 'line',
                    countryType: 'country'
                }
            }))
        } else {
            setMetaCountry([])
        }
    }, [countries])

    const options = {
        chart: {
            id: 'basic-line-chart',
            toolbar: {
                show: false,
            },
            dropShadow: {
                enabled: false,
            },
        },
        stroke: {
            width: 3,
        },
        colors: ['#5171E0', '#5FB2CD', '#FFB300'],
        xaxis: {
            tickAmount: 4,
            labels: {
                show: true,
                rotate: 0,
                formatter: (value) => {
                    if (value == null) return '';
                    const [a, b] = String(value).split('-').map(s => s.trim());
                    return b ? `${a} - ${b}` : a;  // <- evita “-undefined”
                },
                style: {
                    fontSize: '9px',
                    fontFamily: 'Open Sans',
                }
            },
            axisBorder: { show: true },
            axisTicks: { show: false },
            categories: xdata.map(item =>
                frequencyValue === "Annual"
                    ? String(item).split('-')[0].trim()
                    : String(item)
            ),
        },
        yaxis: {
            show: true,
            labels: {
                show: false
            },
            axisBorder: {
                show: true
            }
        },
        grid:
        {
            show: false,
        },
        legend: {
            position: 'top',
            fontFamily: 'Open Sans',
            horizontalAlign: 'left',
            markers: {
                size: 5
            }
        },
        tooltip: {
            y: {
                formatter: function (value) {
                    // Si el valor es null, undefined, NaN o 0, mostrar "N/A"
                    if (value === null || value === undefined || isNaN(value)) {
                        return 'N/A'
                    }
                    return roundy(value, 2)
                }
            }
        }
    };


    const series = ydata.slice(0, 3)

    // const changeData = useSelector(state => state.cardUpdate)
    // const {cardInfo} = changeData

    // useEffect(() => {
    //     if(cardInfo){
    //         setRealData(cardInfo.data_dict)
    //     }
    // }, [changeData])


    const changeUnitHandler = (unit) => {
        setUnitValue(unit)
        console.log("!!!!!!!!!!! unit", unit)
        console.log("!!!!!!!!!!! unitvalue", unitValue)
        setDefinitonValue(meta.units_definitions[unit])
    }

    const changeFrequencyHandler = async (frequency) => {
        // console.log("changeFrequencyHandler")
        // let a = otherFrequenciesList
        // if(otherFrequenciesList.includes(',')){
        let a = otherFrequenciesList.split(',').filter(item => item != frequency)
        // }else if(otherFrequenciesList.includes('and')){
        //     a = otherFrequenciesList.split('and').filter(item => item != frequency)
        // }
        a.push(frequencyValue)
        let result = a.join(',')
        setFrequencyValue(frequency)
        setOtherFrequencyList(result)
        const countryParam = (countries == null ? [] : countries.map(item => item.label))
        // console.log("area: ", meta.area)
        // console.log("topic: ", meta.topic)
        // console.log("indicator: ", meta.indicator)
        // console.log("countries: ", countryParam)
        // console.log("unit: ", unitValue)

        let freq = frequency.replaceAll(' ', '')
        freq = freq[0].toUpperCase() + freq.slice(1)
        updateCard(meta.topic, meta.indicator, meta.countries_used, unitValue, freq)

        // Notificar al componente padre sobre el cambio de frecuencia
        if (onFrequencyChange) {
            console.log(`✅ SearchCard: Notificando cambio de frecuencia para "${meta.indicator}" a "${freq}"`);
            onFrequencyChange(meta.indicator, freq)
        }
    }

    const downloadHandler = () => {
        try {
            // Verificar que hay datos para descargar
            if (!realData || realData.length === 0) {
                console.error('No hay datos para descargar');
                alert('No hay datos disponibles para descargar');
                return;
            }

            // Filtrar datos por la frecuencia y unidad actual
            const filteredData = realData.filter(item =>
                item.frequency.toLowerCase().trim() === frequencyValue.toLowerCase().trim() &&
                item.unit.toLowerCase().trim() === unitValue.toLowerCase().trim()
            );

            if (filteredData.length === 0) {
                console.error('No hay datos para la frecuencia y unidad seleccionadas');
                alert(`No hay datos disponibles para ${frequencyValue} - ${unitValue}`);
                return;
            }

            console.log('Descargando datos:', filteredData.length, 'registros', `(${frequencyValue}, ${unitValue})`);

            // Preparar los datos para el Excel
            const sortData = filteredData.map(item => ({
                indicator: meta.indicator,
                country: item.country,
                frequency: item.frequency,
                period: item.period,
                date: item.date,
                unit: item.unit,
                definition: item.definition,
                source: item.source,
                value: item.value,
                other_frequencies: item.other_frequencies
            }));

            // Crear worksheet
            const worksheet = XLSX.utils.json_to_sheet(sortData);

            // Crear workbook y agregar la hoja
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

            // Generar nombre de archivo seguro
            const safeIndicatorName = meta.indicator.replace(/[^a-z0-9]/gi, '_').substring(0, 50);
            const fileName = `${safeIndicatorName}-${frequencyValue}-${unitValue}.xlsx`;

            // Descargar el archivo
            XLSX.writeFile(workbook, fileName);

            console.log('Descarga completada:', fileName);
        } catch (error) {
            console.error('Error al descargar:', error);
            alert('Error al generar el archivo de descarga');
        }
    }
    const viewerHandler = () => {
        setViewerModal(true)
    }

    // const setIndicator = async (indicator) => {
    //     dispatch({
    //         type: SELECTED_INDICATOR,
    //         payload: indicator
    //     })
    // }



    const folderInfo = useSelector(state => state.listFolder)
    const { loading: loadingFolder, error: errorFolder, folderList } = folderInfo

    // const folderCopy = folderList ? [...folderList]: []

    const folderOptions = folderList?.map(item => ({
        value: item.id,
        label: item.folder_name,
    }))

    const favoriteHandler = () => {

        if (userInfo) {
            setSaveType('favorite')
            dispatch({
                type: SAVE_SERIES_RESET,
            })
            dispatch(setIndicator(meta.indicator))
            let mainId = folderList?.filter(item => item.folder_name == 'Main Folder')[0].id
            // console.log(`default_${finalMeta.indicator}`)
            dispatch(saveSeries([mainId], finalMeta, finalMeta.indicator))
            // dispatch({
            //     type: SAVE_SERIES_RESET,
            // })
        } else {
            setLoginModal(true)
        }
    }

    const addFolderHandler = () => {
        if (userInfo) {
            setSaveType('folders')
            dispatch({
                type: SAVE_SERIES_RESET,
            })
            dispatch(setIndicator(meta.indicator))
            setMetaSender(finalMeta)
            setAddFolderModal(true)
        } else {
            setLoginModal(true)
        }
    }

    const saveInfo = useSelector(state => state.saveSeries)
    const { loading, error, success } = saveInfo

    const selectedIndicator = useSelector(state => state.selectedIndicator)
    const { indicator } = selectedIndicator

    useEffect(() => {
        if (success && indicator == meta.indicator) {
            setModalTitle('Saved')
            // console.log("saveType", saveType)
            if (saveType == 'favorite') {
                setModalMessage('The series has been successfully saved to the "Main Folder".')
            } else {
                setModalMessage('The series has been successfully in folders.')
            }
            setMessageModal(true)
            // dispatch({
            //     type: SAVE_SERIES_RESET,
            // })
        }
    }, [indicator, meta.indicator, saveInfo, saveType, success])

    const closeViewerHandler = () => {
        setViewerModal(false)
    }
    const closeFolderHandler = () => {
        setAddFolderModal(false)
        // dispatch({type: SAVE_SERIES_RESET})
    }
    const closeMessageHandler = () => {
        setMessageModal(false)
        setModalTitle('')
        setModalMessage('')
    }

    const [updateData, setUpdateData] = useState(null)
    // let updateData = null

    const updateCard = async (topic, indicator, country, unit, frequency) => {
        try {
            const config = {
                headers: {
                    'Content-type': 'application/json'
                }
            }

            const { data } = await axios.post(
                '/api/v1/data/change-card-data/', {
                topic: topic,
                indicator: indicator,
                country: country,
                unit: unit,
                frequency: frequency,
            },
                config
            )

            setUpdateData(data)

        } catch (error) {
            console.log("error")
        }
    }

    useEffect(() => {
        if (updateData) {
            console.log(`🔄 Actualizando datos de la tarjeta "${meta.indicator}":`, updateData);
            console.log(`📊 Datos recibidos (primeros 3):`, updateData.data_dict?.slice(0, 3));
            setRealData(updateData.data_dict)
        }
    }, [updateData])

    // Obtener lista de todos los países disponibles para este indicador
    const availableCountriesList = meta.available_countries_list && meta.available_countries_list.length > 0
        ? meta.available_countries_list
        : [...new Set(realData.map(item => item.country))].sort()

    const allAvailableCountries = availableCountriesList.join(', ')

    // Filtrar selected countries para mostrar solo los que están disponibles para este indicador
    const selectedAvailableCountries = meta.countries_used && meta.countries_used.length > 0
        ? meta.countries_used.filter(country => availableCountriesList.includes(country))
        : []

    return (
        <div className='search-card' style={{
            borderRadius: '20px',
            border: '2px solid #000',
            marginBottom: '20px',
            padding: isExpanded ? '30px' : '25px',
            transition: 'all 0.3s ease'
        }}>
            {/* Título centrado */}
            <div className='text-center' style={{ marginBottom: isExpanded ? '20px' : '15px' }}>
                <h4 style={{ fontWeight: 'bold', margin: 0 }}>
                    {meta.indicator}
                </h4>
            </div>

            {/* Sección expandible */}
            {isExpanded && (
                <>
                    {/* Topic y Area */}
                    <div className='d-flex justify-content-center align-items-center mb-3' style={{ gap: '30px' }}>
                        <div className='d-flex align-items-center'>
                            <i className="fa-solid fa-layer-group me-2" style={{ color: '#666' }}></i>
                            <span style={{ fontSize: '14px', color: '#666' }}>{meta.area.split('_')[1]}</span>
                        </div>
                        <div className='d-flex align-items-center'>
                            <i className="fa-solid fa-book me-2" style={{ color: '#666' }}></i>
                            <span style={{ fontSize: '14px', color: '#666' }}>{meta.topic.split('_')[1]}</span>
                        </div>
                    </div>
                </>
            )}

            {/* Línea separadora */}
            <hr style={{ borderTop: '1px solid #D9D9D9', margin: '15px 0' }} />

            {/* Selectores de Frequency y Unit */}
            <Row className='mb-3'>
                <Col md={6} className='pe-md-2'>
                    <p className='text-center mb-2' style={{ fontWeight: '600', fontSize: '15px', color: '#333' }}>Frequency:</p>
                    <Dropdown style={{ width: '100%' }}>
                        <Dropdown.Toggle
                            style={{
                                width: '100%',
                                backgroundColor: 'white',
                                border: '1.5px solid #ccc',
                                color: '#555',
                                borderRadius: '10px',
                                padding: '10px 15px',
                                fontSize: '14px',
                                fontWeight: '500',
                                textAlign: 'center',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                            title={`${frequencyValue.trim()?.charAt(0).toUpperCase()}${frequencyValue.trim().slice(1)}`}
                        >
                            {`${frequencyValue.trim()?.charAt(0).toUpperCase()}${frequencyValue.trim().slice(1)}`}
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ width: '100%', maxHeight: '300px', overflowY: 'auto' }}>
                            {otherFrequenciesList.split(',').map((item, index) => {
                                const displayText = `${item.trim().charAt(0).toUpperCase()}${item.trim().slice(1)}`;
                                const isActive = item.trim() === frequencyValue.trim();

                                return (
                                    <Dropdown.Item
                                        key={index}
                                        onClick={e => changeFrequencyHandler(item)}
                                        className={`${isActive ? 'active' : ''}`}
                                        style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            paddingRight: isActive ? '30px' : '10px',
                                            backgroundColor: isActive ? '#007bff' : '',
                                            color: isActive ? 'white' : ''
                                        }}
                                        title={displayText}
                                    >
                                        {displayText}
                                        {isActive && <i className="fa-solid fa-check" style={{
                                            position: 'absolute',
                                            right: '10px',
                                            color: 'white'
                                        }}></i>}
                                    </Dropdown.Item>
                                );
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col md={6} className='ps-md-2'>
                    <p className='text-center mb-2' style={{ fontWeight: '600', fontSize: '15px', color: '#333' }}>Unit:</p>
                    <Dropdown style={{ width: '100%' }}>
                        <Dropdown.Toggle
                            style={{
                                width: '100%',
                                backgroundColor: 'white',
                                border: '1.5px solid #ccc',
                                color: '#555',
                                borderRadius: '10px',
                                padding: '10px 15px',
                                fontSize: '14px',
                                fontWeight: '500',
                                textAlign: 'center',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                            title={unitValue.charAt(0).toUpperCase() + unitValue.slice(1)}
                        >
                            {unitValue.charAt(0).toUpperCase() + unitValue.slice(1)}
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ width: '100%', maxHeight: '300px', overflowY: 'auto' }}>
                            {meta.units.sort((a, b) => a.localeCompare(b)).map((item, index) => {
                                const displayText = item.charAt(0).toUpperCase() + item.slice(1);
                                const isActive = item === unitValue;

                                return (
                                    <Dropdown.Item
                                        key={index}
                                        onClick={e => changeUnitHandler(item)}
                                        className={`unit-dropdown-item ${isActive ? 'active' : ''}`}
                                        style={{
                                            overflow: 'hidden',
                                            position: 'relative',
                                            paddingRight: isActive ? '30px' : '10px',
                                            backgroundColor: isActive ? '#007bff' : '',
                                            color: isActive ? 'white' : ''
                                        }}
                                        title={displayText}
                                        onMouseEnter={(e) => {
                                            const element = e.currentTarget;
                                            const textSpan = element.querySelector('.unit-text');
                                            if (textSpan) {
                                                const containerWidth = element.clientWidth - (isActive ? 40 : 20);
                                                const textWidth = textSpan.scrollWidth;

                                                if (textWidth > containerWidth) {
                                                    const overflow = textWidth - containerWidth;
                                                    const duration = Math.max(2, overflow / 30); // Más lento: 30px por segundo

                                                    textSpan.style.transition = `transform ${duration}s linear`;
                                                    textSpan.style.transform = `translateX(-${overflow}px)`;
                                                }
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            const textSpan = e.currentTarget.querySelector('.unit-text');
                                            if (textSpan) {
                                                textSpan.style.transition = 'transform 0.3s ease';
                                                textSpan.style.transform = 'translateX(0)';
                                            }
                                        }}
                                    >
                                        <span className="unit-text" style={{
                                            display: 'inline-block',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {displayText}
                                        </span>
                                        {isActive && <i className="fa-solid fa-check" style={{
                                            position: 'absolute',
                                            right: '10px',
                                            color: 'white'
                                        }}></i>}
                                    </Dropdown.Item>
                                );
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>

            {/* Sección expandible con información adicional */}
            {isExpanded && (
                <>
                    <hr style={{ borderTop: '1px solid #D9D9D9', margin: '15px 0' }} />

                    {/* Definition */}
                    <div className='mb-3'>
                        <h6 style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '10px' }}>Definition</h6>
                        <p style={{ fontSize: '14px', color: '#555', lineHeight: '1.6', textAlign: 'justify' }}>
                            {definitionValue}
                        </p>
                    </div>

                    {/* Selected available countries */}
                    <div className='mb-3'>
                        <p style={{ fontSize: '14px', marginBottom: '5px' }}>
                            <strong>Selected available countries:</strong> {selectedAvailableCountries.length > 0
                                ? selectedAvailableCountries.join(', ')
                                : 'No selected countries with data'}
                        </p>
                    </div>

                    {/* Available countries (todos) */}
                    <div className='mb-3'>
                        <p style={{ fontSize: '14px', marginBottom: '5px' }}>
                            <strong>Available countries:</strong> {allAvailableCountries}
                        </p>
                    </div>

                    {/* Available timeframe */}
                    <div className='mb-3'>
                        <p style={{ fontSize: '14px', marginBottom: '5px' }}>
                            <strong>Available timeframe:</strong> {minDate} - {maxDate}
                        </p>
                    </div>

                    {/* Sources */}
                    <div className='mb-3'>
                        <p style={{ fontSize: '14px', marginBottom: '5px' }}>
                            <strong>Sources:</strong> {sourcesList.join(', ')}
                        </p>
                    </div>
                </>
            )}

            {/* Vista colapsada - solo mostrar resumen */}
            {!isExpanded && (
                <>
                    {/* Selected available countries */}
                    <div className='text-center mb-2'>
                        <p style={{ fontWeight: 'bold', fontSize: '15px', marginBottom: '5px' }}>Selected available countries:</p>
                        <p style={{ fontSize: '14px', color: '#555' }}>
                            {selectedAvailableCountries.length > 0
                                ? selectedAvailableCountries.join(', ')
                                : 'No selected countries with data'}
                        </p>
                    </div>

                    {/* Available countries */}
                    <div className='text-center mb-3'>
                        <p style={{ fontWeight: 'bold', fontSize: '15px', marginBottom: '5px' }}>Available countries:</p>
                        <p style={{ fontSize: '22px', fontWeight: 'bold', margin: 0 }}>{meta.total_countries_available}</p>
                    </div>
                </>
            )}

            {/* Botones */}
            <div className='d-flex align-items-center gap-2 mt-3'>
                {/* Botón Download */}
                <button
                    onClick={downloadHandler}
                    style={{
                        flex: '1',
                        backgroundColor: '#1a3a52',
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '12px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#0f2a3d'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#1a3a52'}
                >
                    Download
                </button>

                {/* Botón de Gráfico (Viewer) */}
                <button
                    onClick={viewerHandler}
                    style={{
                        width: '50px',
                        height: '50px',
                        backgroundColor: 'white',
                        border: '2px solid #ccc',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s',
                        padding: '0'
                    }}
                    onMouseOver={(e) => e.target.style.borderColor = '#999'}
                    onMouseOut={(e) => e.target.style.borderColor = '#ccc'}
                    title="Open in Viewer"
                >
                    <i className="fa-solid fa-chart-line" style={{ fontSize: '20px', color: '#555' }}></i>
                </button>

                {/* Botón View More/Less */}
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    style={{
                        flex: '1',
                        backgroundColor: 'white',
                        color: '#333',
                        border: '2px solid #ccc',
                        borderRadius: '10px',
                        padding: '12px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.borderColor = '#999'}
                    onMouseOut={(e) => e.target.style.borderColor = '#ccc'}
                >
                    {isExpanded ? 'View Less' : 'View More'}
                </button>
            </div>

            {/* Modales */}
            {viewerModal && (
                <ViewerModal meta={finalMeta} closeCallback={closeViewerHandler} />
            )}

            {addFolderModal && (
                <AddFolderModal closeCallback={closeFolderHandler} meta={metaSender} folders={folderOptions} />
            )}
            {messageModal && (
                <MessageModal closeCallback={closeMessageHandler} title={modalTitle} message={modalMessage} />
            )}

            {loginModal && (
                <LoginModal
                    closeCallback={() => { setLoginModal(false) }}
                    registerCallback={e => { setLoginModal(false); setRegisterModal(true) }}
                    forgotCallback={e => { setLoginModal(false); setForgotModal(true) }}
                    isViewer={true} />
            )}

            {registerModal && (
                <RegisterModal closeCallback={() => { setRegisterModal(false) }} loginCallback={e => { setRegisterModal(false); setLoginModal(true) }} />
            )}

            {forgotModal && (
                <ForgotModal closeCallback={() => { setForgotModal(false) }} />
            )}
        </div>
    )
}

export default SearchCard
